import React, { useEffect, useRef } from 'react';
import Header from './components/header';
import Section from './components/section';
import Section2 from './components/section2';
import AboutSection from './components/aboutSection';
import Footer from './components/Footer';
import "./secondPage.css";
import music from "./sounds/1.mp3"
import playButton from "./images/play.png";
import pauseButton from "./images/pause.png";


const SecondPage = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(music);
    audio.loop = true;
    audioRef.current = audio;
    audio.play();

    return () => {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
    };
  }, []);

  const handlePlay = () => {
    audioRef.current?.play();
  };

  const handlePause = () => {
    audioRef.current?.pause();
  };

  return (
    <div>
      <Header />
      <Section />
      <div className="barra">
        <div className="texto-animado">ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
        </div>
      </div>
      <Section2 />
      <div className="barra">
        <div className="texto-animado">ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
        </div>
      </div>
      <AboutSection />
      <div className="barra">
        <div className="texto-animado">ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
          ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA ROBINIGGA
        </div>
      </div>
      <Footer />
      <div style={{ position: 'relative' }}>
        <button onClick={handlePlay} style={{ position: 'absolute', bottom: '20px', right: '80px', border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}>
          <img src={playButton} alt="Play" style={{ width: '100px', height: '100px' }} />
        </button>
        <button onClick={handlePause} style={{ position: 'absolute', bottom: '20px', right: '20px', border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}>
          <img src={pauseButton} alt="Pause" style={{ width: '100px', height: '100px' }} />
        </button>
      </div>
    </div>
  );
}

export default SecondPage;
